import { Form as AntdForm, type FormProps } from "antd/es";
import React from "react";

import { cx } from "~/tools/class-variance";

export const Form: React.FC<React.PropsWithChildren<FormProps>> = ({ layout = "vertical", className, ...props }) => (
	<AntdForm
		layout={layout}
		role="form"
		{...props}
		className={cx(
			"[&.ant-form-inline_.ant-form-item-label]:leading-10",
			"[&.ant-form-inline_.ant-form-item]:last:mr-0",
			"[&.ant-form-vertical]:space-y-6",
			className,
		)}
	>
		{props.children}
	</AntdForm>
);
